import React from 'react';
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function CustomerAutocomplete(props) {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = React.useState('');

    const onSelect = (_tmp, elem) => {
        if (elem) {
            props.selected(elem.id, elem);
            setInputValue('');
        }
    };

    const filterOptions = (options, { inputValue: iv }) => {
        if (!iv) return options;
        const lower = iv.toLowerCase();
        return options.filter((o) => o.name && o.name.toLowerCase().includes(lower));
    };

    const inputId = props.id || 'customerautocomplete';

    return (
        <Autocomplete
            options={props.customers}
            getOptionLabel={(option) => option.name || ''}
            id={inputId}
            name={inputId}
            loading={!props.customers}
            loadingText={t('general.loading')}
            value={null}
            inputValue={inputValue}
            onInputChange={(event, newValue, reason) => {
                if (reason !== 'reset') setInputValue(newValue);
            }}
            onChange={onSelect}
            filterOptions={filterOptions}
            isOptionEqualToValue={(option, value) => option != null && value != null && option.id === value.id}
            renderOption={(optProps, option) => (
                <li {...optProps} key={option.id != null ? String(option.id) : option.name}>
                    {option.name}
                </li>
            )}
            renderInput={(params) => (
                <TextField {...params} label={t('general.customer')} margin="normal" autoFocus={props.autoFocus} />
            )}
        />
    );
}

CustomerAutocomplete.propTypes = {
    customers: PropTypes.array.isRequired,
    selected: PropTypes.func.isRequired,
    id: PropTypes.string,
    autoFocus: PropTypes.bool,
};
